import cx from 'classnames'

import { StrongNode, nodes } from 'prose-core'

import { ReactComponent as JiraLogo } from 'assets/icons/logos/jira.svg'
import { JiraIssue } from './types'
import { AnchorOrDiv, Skel } from '../EmbedCommon/common'

import Styles from './JiraIssueInline.module.scss'

export const JiraIssueInline = ({
  node,
  isLoading,
  data,
  preview,
}: {
  node: StrongNode<typeof nodes.jira_embed>
  isLoading: boolean
  data: JiraIssue
  preview?: true
}) => {
  if (isLoading) {
    return (
      <div className={cx(Styles.inline, Styles.isLoading)}>
        <div className={Styles.icon}>
          <JiraLogo width={20} height={20} />
        </div>

        <div className={Styles.body}>
          <Skel />
        </div>
      </div>
    )
  }

  return (
    <div className={cx(Styles.issue, Styles[node.attrs.mode], { [Styles.isLoading]: isLoading })}>
      <img className={Styles.icon} src={data.fields.issuetype.iconUrl} alt={data.fields.issuetype.name} />

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={Styles.content}>
        {`${data.key} #${data.fields.summary}`}
      </AnchorOrDiv>
    </div>
  )
}
